<div class="file-block">

  <span class="label">Ð­ÑÐ¾ Ð½ÐµÐ¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ð¾, Ð½Ð¾ Ð²Ñ Ð¼Ð¾Ð¶ÐµÑÐµ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ ÑÐ°Ð¹Ð»Ñ. ÐÐ½Ð¸ ÑÐ¾Ð¶Ðµ Ð¾ÑÐ¾Ð±ÑÐ°Ð·ÑÑÑÑ Ð² Ð¾Ð±ÑÑÐ²Ð»ÐµÐ½Ð¸Ð¸.</span>

  <div *ngIf="fileToUpload && fileToUpload.length" class="file-container">

    <arm-file-upload *ngFor="let file of fileToUpload; let i = index;" [index]="i" ></arm-file-upload>

  </div>

  <div class="file-wrapper" armDragDrop (onFileDropped)="handleFileInput($event)">

    <span>ÐÐµÑÐµÑÐ°ÑÐ¸ÑÐµ ÑÐ°Ð¹Ð»Ñ Ð¸Ð»Ð¸ Ð²ÑÐ±ÐµÑÐ¸ÑÐµ Ð½Ð° ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐµ</span>

    <label for="file-input">
      <img src="assets/img/file/attach.svg" alt=""/>
      <span>ÐÑÐ±ÑÐ°ÑÑ</span>
    </label>

    <input type="file"
           id="file-input"
           (change)="handleFileInput($event.target.files)"
           accept=".JPG, .PNG, .GIF, .AVI, .MP4, .3GP, .MPEG, .MOV, .MP3, .FLV, .WMV,.pdf, .doc, .xls, .docx, .xlsx, .txt, .pptx, .pages, .rtf, .ppt, .key, .xlsx, .numbers"
           multiple>
  </div>

</div>
